import React, { useState } from "react";
import { motion } from "framer-motion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { useSelector } from "react-redux";

import "../../style/Plans/_newPlan.scss";
import { ReactComponent as SadFace } from "../../assets/new-icons/tradizionaleFace.svg";
import { ReactComponent as RelaxFace } from "../../assets/new-icons/relaxFace.svg";
import { ReactComponent as HappyFace } from "../../assets/new-icons/ricaricabileFace.svg";
import { ReactComponent as LogoWhite } from "../../assets/img/logo_esteso_wh.svg";
import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import { DateTime } from "luxon";

function NewPlanRecap() {
  const navigate = useNavigate();
  const currentPlan = useSelector((user) => user?.user?.idGruppo);
  const [showScroll, setShowScroll] = useState(false);
  const defaultMethod = useSelector((user) => user.user.payMethodDefault);
  const iban = useSelector((user) => user.user.datiPagamento.account_iban);
  const token = useSelector((user) => user.user.datiPagamento.token);

  const getPlanName = () => {
    switch (currentPlan) {
      case 1:
        return "Ricaricabile";
      case 2:
        return "Relax";

      case 3:
        return "Tradizionale";
      default:
        break;
    }
  };
  const getPlanFace = () => {
    switch (currentPlan) {
      case 1:
        return <HappyFace />;
      case 2:
        return <RelaxFace />;

      case 3:
        return <SadFace />;
      default:
        break;
    }
  };
  return (
    <div
      className={`newPlan ${
        currentPlan === 3 ? "red" : currentPlan === 2 ? "orange" : "green"
      }`}
    >
      <div className="newPlan-top">
        <header>
          <div className="logo">
            <LogoWhite />
          </div>
        </header>
        <div className="text">
          <div className="icon">{getPlanFace()}</div>
          <p className="secondary">Il tuo nuovo piano</p>
          <p className="main">{getPlanName()}</p>
        </div>
      </div>
      <div className="newPlan-bottom">
        <div className="boxSwipe">
          <p className="labelSwipe">Perfetto</p>
          <div className="icon">
            <Check className="check" />
          </div>
        </div>
        <div className="recapInfo">
          <p className="main">Modifiche effettuate</p>
          <p className="secondary">
            Da questo momento in poi il nuovo Piano è già attivo con tutte le
            relative caratteristiche e i suoi vantaggi.
          </p>
          <p className="secondary">
            Attenzione: l'applicazione del Piano non è retroattiva. I costi già
            sostenuti e gli addebiti già inviati non possono essere modificati o
            annullati.
          </p>
          <p className="secondary">
            Se hai pagamenti in corso, l'addebito avverrà comunque su{" "}
            <span className="bold">
              {defaultMethod && defaultMethod === "RID"
                ? `Conto Corrente **** ${iban.slice(iban.length - 4)}`
                : `Carta di Credito **** ${token.slice(token.length - 4)}`}
            </span>
          </p>
          <p className="label">
            Nel frattempo, ecco alcuni suggerimenti revoluzionari che abbiamo
            scelto per te:
          </p>
          <div className="buttonBox">
            <button onClick={() => navigate("/enrica")}>
              <p>Home</p>
              <ArrowForwardIos />
            </button>
            <button onClick={() => navigate("/enrica/ricarica")}>
              <p>Fai una ricarica</p>
              <ArrowForwardIos />
            </button>
            <button href="https://my.revoluce.it/appuntamento/">
              <p>Presenta un amico</p>
              <ArrowForwardIos />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewPlanRecap;
